(function (window, document) {
'use strict';
var VERSION = 'gcitypartners-opportunities-runtime-p0-08';
var ROOT_SELECTOR = '[data-gcitypartners-page-system]';
var LOCATION_ENDPOINT = '/apps/gcity-api/property/location/search';
var OPPORTUNITY_TYPES = [
'tender',
'competition',
'funding',
'partnership',
'property',
'programme'
];
var CLOSED_STATES = [
'closed',
'expired',
'withdrawn',
'cancelled',
'rejected',
'completed'
];
var ENDPOINT_PATHS = [
'/api/opportunities',
'/api/programmes/recreation',
'/api/programmes/cultural'
];
function clean(value) {
return String(value == null ? '' : value).trim();
}
function slug(value) {
return clean(value).toLowerCase().replace(/_/g, '-');
}
function isZh(root) {
var language = clean(
document.documentElement.getAttribute('lang') ||
(root && root.getAttribute('data-locale')) ||
''
).toLowerCase();
return language.indexOf('zh') === 0;
}
function words(root, zh, en) {
return isZh(root) ? zh : en;
}
function asObject(value) {
return value && typeof value === 'object' && !Array.isArray(value)
? value
: {};
}
function asArray(value) {
if (Array.isArray(value)) return value;
if (!value) return [];
if (Array.isArray(value.items)) return value.items;
if (Array.isArray(value.results)) return value.results;
if (Array.isArray(value.locations)) return value.locations;
if (Array.isArray(value.data)) return value.data;
if (value.data && Array.isArray(value.data.items)) return value.data.items;
if (value.data && Array.isArray(value.data.results)) return value.data.results;
return [];
}
function boolValue(value) {
return value === true || value === 'true' || value === 1 || value === '1';
}
function createAbortController() {
return typeof window.AbortController === 'function'
? new window.AbortController()
: null;
}
function abortController(controller) {
if (!controller || typeof controller.abort !== 'function') return;
try {
controller.abort();
} catch (_) {}
}
function addCleanup(root, cleanup) {
if (!root.__gcpPageSystemCleanups) {
root.__gcpPageSystemCleanups = [];
}
root.__gcpPageSystemCleanups.push(cleanup);
}
function listen(root, target, type, handler, options) {
if (!target || typeof target.addEventListener !== 'function') return;
target.addEventListener(type, handler, options || false);
addCleanup(root, function () {
target.removeEventListener(type, handler, options || false);
});
}
function markBlocked(root, reason) {
if (!root) return;
root.setAttribute('data-runtime-state', 'blocked');
root.setAttribute('data-runtime-reason', reason);
}
function getCanonicalRoot() {
var roots = Array.prototype.slice.call(
document.querySelectorAll(ROOT_SELECTOR)
);
var publicRoots = roots.filter(function (root) { return root.hasAttribute('data-gcp-public-tabs'); });
if (publicRoots.length === 1) return publicRoots[0];
if (roots.length === 0) return null;
if (roots.length !== 1) {
roots.forEach(function (root) {
markBlocked(root, 'invalid-gcitypartners-root-count');
});
return null;
}
return roots[0];
}
function registerEndpoints(root) {
var executor = window.GCityExecutor;
if (!executor || !executor.ENDPOINT_REGISTRY) return;
var registry = executor.ENDPOINT_REGISTRY;
var baseContract = {
api_family: 'gcity-core-api',
api_tier: 'daily_platform',
delivery_type: 'api',
delivery_method: 'instant',
engine_type: 'decision_engine',
result_surface: 'workspace',
requires_gfun: false,
read_only: true
};
ENDPOINT_PATHS.forEach(function (path) {
if (registry[path]) return;
registry[path] = Object.assign({}, baseContract, {
canonical_endpoint: path,
result_surface: 'workspace'
});
});
root.setAttribute('data-opportunity-endpoints-registered', 'true');
}
function coreBase() {
var context = asObject(window.GCITY_CONTEXT);
var api = asObject(context.api);
var root = getCanonicalRoot();
return clean((root && root.getAttribute('data-opportunities-api-base')) || api.core_base || '/apps/gcity-api/core').replace(/\/+$/, '');
}
function endpointUrl(path, params) {
var rawPath = clean(path);
var url;
if (/^https?:\/\//i.test(rawPath)) {
url = new URL(rawPath);
} else {
url = new URL(coreBase() + '/' + rawPath.replace(/^\/+/, ''), window.location.origin);
}
Object.keys(params || {}).forEach(function (key) {
var value = params[key];
if (value === '' || value === false || value == null) return;
url.searchParams.set(key, String(value));
});
return url.toString();
}
function fetchJson(path, params, controller) {
return window.fetch(endpointUrl(path, params), {
method: 'GET',
credentials: 'same-origin',
headers: { Accept: 'application/json' },
signal: controller && controller.signal
}).then(function (response) {
return response.json().catch(function () {
var error = new Error('invalid_opportunity_json');
error.status = response.status;
throw error;
}).then(function (payload) {
if (!response.ok || (payload && (payload.ok === false || payload.success === false || payload.source_status === 'unavailable'))) {
var error = new Error('request_' + response.status);
error.status = response.status;
error.payload = payload;
throw error;
}
return payload;
});
});
}
function safeHttpsUrl(value) {
try {
var raw = clean(value);
if (!/^https:\/\//i.test(raw)) return '';
var url = new URL(raw);
if (url.protocol !== 'https:') return '';
if (url.username || url.password) return '';
if (!url.hostname || url.hostname === 'localhost') return '';
return url.toString();
} catch (_) {
return '';
}
}
function normalizeAvailability(item) {
var availability = asObject(item.availability);
var registration = asObject(item.registration);
var state = slug(
availability.status ||
registration.status ||
item.availability_status ||
item.status ||
'unknown'
);
if (['registration-open', 'available'].indexOf(state) > -1) return 'open';
if (['registration-closed', 'expired', 'full'].indexOf(state) > -1) return 'closed';
if (['registration-not-started', 'upcoming', 'not-started'].indexOf(state) > -1) return 'not-started';
if (['programme-cancelled', 'canceled'].indexOf(state) > -1) return 'cancelled';
if (['programme-completed', 'finished'].indexOf(state) > -1) return 'completed';
return state || 'unknown';
}
function parseDate(value) {
var input = clean(value);
if (!input) return null;
var date = new Date(input);
return Number.isNaN(date.getTime()) ? null : date;
}
function formatDate(root, value) {
var date = parseDate(value);
if (!date) return clean(value);
try {
return new Intl.DateTimeFormat(isZh(root) ? 'zh-HK' : 'en-GB', {
year: 'numeric',
month: 'short',
day: 'numeric',
hour: date.getHours() || date.getMinutes() ? '2-digit' : undefined,
minute: date.getHours() || date.getMinutes() ? '2-digit' : undefined
}).format(date);
} catch (_) {
return date.toLocaleString();
}
}
function normalizeFee(root, value) {
var fee = asObject(value);
if (boolValue(fee.free) || slug(fee.status) === 'free') return words(root, '免費', 'Free');
if (fee.amount != null && clean(fee.amount) !== '') return clean(fee.currency || 'HKD') + ' ' + clean(fee.amount);
return clean(value && typeof value !== 'object' ? value : fee.label);
}
function normalizeOpportunity(root, item, index, programme) {
var record = asObject(item);
var verified = boolValue(record.verified) || slug(record.verification_status) === 'verified';
var publishable = boolValue(record.is_publishable);
var officialUrl = safeHttpsUrl(record.official_url || record.source_url || record.url);
var title = clean(record.title || record.name);
if (!verified || !publishable || !officialUrl || !title) return null;
var availability = asObject(record.availability);
var registration = asObject(record.registration);
var venue = asObject(record.venue);
var sessions = Array.isArray(record.sessions) ? record.sessions : [];
var firstSession = asObject(sessions[0]);
var state = programme ? normalizeAvailability(record) : slug(record.status || 'open');
var deadline = clean(record.deadline || registration.deadline || firstSession.starts_at);
if (!programme && CLOSED_STATES.indexOf(state) > -1) return null;
var deadlineDate = parseDate(deadline);
if (!programme && deadlineDate && deadlineDate.getTime() < Date.now()) return null;
return {
id: clean(record.id || 'opportunity-' + index),
title: title,
summary: clean(record.summary || record.description),
organizer: clean(record.organizer || record.organization || record.issuer),
region: clean(record.region || record.district || venue.district),
deadline: deadline,
officialUrl: officialUrl,
source: clean(record.source || record.provider),
state: state || 'unknown',
programme: programme,
venue: clean(venue.name || record.venue_name),
session: clean(firstSession.starts_at),
age: Array.isArray(record.age_group) ? record.age_group.join(' / ') : clean(record.age_group),
fee: normalizeFee(root, record.fee),
verifiedAt: clean(availability.verified_at || record.last_verified_at || record.verified_at)
};
}
function extractPayload(payload) {
var envelope = asObject(payload);
var data = asObject(envelope.data);
var items = [];
var hasRecordsArray = [envelope.items, envelope.results, data.items, data.results].some(function (candidate) {
if (!Array.isArray(candidate)) return false;
items = candidate;
return true;
});
if (!hasRecordsArray) throw new Error('invalid_opportunity_payload');
return {
items: items,
sourceStatus: clean(envelope.source_status || data.source_status || envelope.status || 'ready'),
meta: asObject(envelope.meta)
};
}
function createElement(tag, className, textValue) {
var node = document.createElement(tag);
if (className) node.className = className;
if (textValue != null) node.textContent = textValue;
return node;
}
function appendMeta(meta, value) {
if (!clean(value)) return;
meta.appendChild(createElement('span', '', clean(value)));
}
function availabilityLabel(root, state) {
var labels = {
open: ['報名開放', 'Open'],
closed: ['已截止', 'Closed'],
'not-started': ['尚未開始', 'Not started'],
cancelled: ['已取消', 'Cancelled'],
completed: ['已完結', 'Completed'],
unknown: ['待官方確認', 'Awaiting official confirmation']
};
var pair = labels[state] || labels.unknown;
return words(root, pair[0], pair[1]);
}
function renderOpportunityCard(root, record, opportunityType) {
var card = createElement('article', 'gcp-opportunity-card');
card.setAttribute('data-gcp-opportunity-id', record.id);
var source = record.organizer || record.source || words(root, '官方來源', 'Official source');
card.appendChild(createElement('small', '', source));
card.appendChild(createElement('strong', '', record.title));
if (record.summary) card.appendChild(createElement('p', '', record.summary));
var meta = createElement('div', 'gcp-opportunity-meta');
appendMeta(meta, record.region);
appendMeta(meta, record.deadline ? words(root, '截止：', 'Deadline: ') + formatDate(root, record.deadline) : '');
appendMeta(meta, record.verifiedAt ? words(root, '核實：', 'Verified: ') + formatDate(root, record.verifiedAt) : '');
if (meta.childNodes.length) card.appendChild(meta);
if (record.programme) {
var programmeMeta = createElement('div', 'gcp-programme-meta');
appendMeta(programmeMeta, record.venue);
appendMeta(programmeMeta, record.age);
appendMeta(programmeMeta, record.fee);
if (programmeMeta.childNodes.length) card.appendChild(programmeMeta);
var availability = createElement('div', 'gcp-availability');
availability.setAttribute('data-state', record.state);
availability.appendChild(createElement('strong', '', availabilityLabel(root, record.state)));
if (record.session || record.deadline) availability.appendChild(createElement('small', '', formatDate(root, record.session || record.deadline)));
card.appendChild(availability);
}
var link = createElement('a', 'gcp-btn gcp-btn--compact', words(root, '查看官方公告', 'Open official source'));
link.href = record.officialUrl;
link.target = '_blank';
link.rel = 'noopener noreferrer';
link.setAttribute('data-gcp-official-source-link', '');
link.appendChild(createElement('span', '', '↗'));
link.lastChild.setAttribute('aria-hidden', 'true');
card.appendChild(link);
var briefLink = createElement('a', 'gcp-btn gcp-btn--compact', words(root, '建立項目簡報', 'Build project brief'));
briefLink.href = '#gcp-brief-form';
briefLink.setAttribute('data-no-legacy-normalize', 'true');
briefLink.setAttribute('data-gcp-brief-context', 'opportunity-record');
briefLink.setAttribute('data-gcp-context-id', record.id);
briefLink.setAttribute('data-gcp-opportunity-type', clean(opportunityType));
card.appendChild(briefLink);
return card;
}
function dispatchRendered(root, count) {
try {
root.dispatchEvent(new CustomEvent('gcitypartners:opportunities-rendered', {
bubbles: true,
detail: { source: 'assets/gcitypartners-page-system.js', count: count }
}));
} catch (_) {}
}
function setFeedState(runtime, state, message) {
const isError = state === 'error';
const isEmpty = state === 'empty';

runtime.feed.setAttribute('data-state', state);
runtime.board.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
runtime.status.textContent = isError ? '' : (message || '');

runtime.error.textContent = isError ? (message || '') : '';
runtime.error.hidden = !isError;
runtime.empty.hidden = !isEmpty;

if (isError || isEmpty) {
runtime.board.replaceChildren();
}
if (state === 'loading' && !runtime.board.childNodes.length) {
var skeleton = createElement('article', 'gcp-opportunity-card gcp-opportunity-skeleton');
skeleton.setAttribute('aria-hidden', 'true');
skeleton.appendChild(createElement('small', '', words(runtime.root, '讀取官方資料', 'Loading official data')));
skeleton.appendChild(createElement('strong', '', '••••••••'));
skeleton.appendChild(createElement('span', '', '••••••••••••••••'));
runtime.board.replaceChildren(skeleton);
}
if (state === 'empty' || state === 'error') runtime.board.replaceChildren();
}
function renderPayload(runtime, payload, options) {
var extracted = extractPayload(payload);
var requestedStatus = clean(runtime.state.filters.status);
var records = extracted.items.map(function (item, index) {
return normalizeOpportunity(runtime.root, item, index, options.programme);
}).filter(Boolean);
if (options.programme && requestedStatus) records = records.filter(function (record) { return record.state === slug(requestedStatus); });
if (!records.length) {
runtime.emptyCopy.textContent = extracted.sourceStatus === 'not_configured'
? words(runtime.root, '此分類的已核實資料來源正在接入。', 'The verified source for this category is being connected.')
: words(runtime.root, '沒有符合目前條件的已核實項目；不會使用假資料補位。', 'No verified record meets the current filters; filler data is not used.');
setFeedState(runtime, 'empty', words(runtime.root, '暫無已核實結果。', 'No verified results.'));
dispatchRendered(runtime.root, 0);
return;
}
runtime.board.replaceChildren.apply(runtime.board, records.map(function (record) {
return renderOpportunityCard(runtime.root, record, runtime.state.type);
}));
setFeedState(runtime, 'ready', words(runtime.root, '已載入 ', 'Loaded ') + records.length + words(runtime.root, ' 個已核實結果。', ' verified records.'));
dispatchRendered(runtime.root, records.length);
}
function normalizeType(value) {
var type = slug(value);
return OPPORTUNITY_TYPES.indexOf(type) > -1 ? type : 'tender';
}
function readFilters(form) {
if (!form) return {};
var data = new FormData(form);
return {
date_from: clean(data.get('date_from')),
date_to: clean(data.get('date_to')),
district: clean(data.get('district')),
age_group: clean(data.get('age_group')),
status: clean(data.get('status')),
free_only: data.get('free_only') === 'true',
online_registration: data.get('online_registration') === 'true'
};
}
function parseUrlState(runtime) {
var params = new URLSearchParams(window.location.search || '');
runtime.state.type = normalizeType(params.get('type'));
runtime.state.programmeSource = slug(params.get('programme_source')) === 'cultural' ? 'cultural' : 'recreation';
runtime.state.filters = {
date_from: clean(params.get('date_from')),
date_to: clean(params.get('date_to')),
district: clean(params.get('district')),
age_group: clean(params.get('age_group')),
status: clean(params.get('status')),
free_only: params.get('free_only') === 'true',
online_registration: params.get('online_registration') === 'true'
};
}
function writeUrlState(runtime, replace) {
var url = new URL(window.location.href);
var filters = runtime.state.filters || {};
url.searchParams.set('type', runtime.state.type);
['programme_source','date_from','date_to','district','age_group','status','free_only','online_registration'].forEach(function (key) { url.searchParams.delete(key); });
if (runtime.state.type === 'programme') {
url.searchParams.set('programme_source', runtime.state.programmeSource);
Object.keys(filters).forEach(function (key) {
var value = filters[key];
if (value === '' || value === false || value == null) return;
url.searchParams.set(key, String(value));
});
}
url.hash = 'opportunities';
try { window.history[replace ? 'replaceState' : 'pushState']({}, '', url.pathname + url.search + url.hash); } catch (_) {}
}
function syncOpportunityUi(runtime) {
runtime.typeLinks.forEach(function (link) {
var selected = normalizeType(link.getAttribute('data-gcp-opportunity-type')) === runtime.state.type;
link.classList.toggle('is-recommended', selected);
if (selected) link.setAttribute('aria-current', 'page');
else link.removeAttribute('aria-current');
});
runtime.programmeTools.hidden = runtime.state.type !== 'programme';
runtime.programmeSources.forEach(function (button) {
var selected = slug(button.getAttribute('data-gcp-programme-source')) === runtime.state.programmeSource;
button.classList.toggle('gcp-btn--primary', selected);
button.setAttribute('aria-pressed', selected ? 'true' : 'false');
});
runtime.intro.textContent = runtime.state.type === 'programme'
? words(runtime.root, '康文署康體及文化活動；名稱、規則以官方來源及核即時間為準。', 'LCSD recreation and cultural programmes; official sources and verification time prevail.')
: words(runtime.root, '只顯示已核實、可發布並可返回官方來源的機會。', 'Only verified, publishable opportunities with official links are shown.');
if (runtime.filterForm) {
Object.keys(runtime.state.filters).forEach(function (key) {
var control = runtime.filterForm.elements[key];
if (!control) return;
if (control.type === 'checkbox') control.checked = runtime.state.filters[key] === true;
else control.value = runtime.state.filters[key] || '';
});
}
}
function requestConfig(runtime) {
if (runtime.state.type === 'programme') {
var source = runtime.state.programmeSource;
var endpoint = runtime.root.getAttribute(source === 'cultural' ? 'data-programme-cultural-endpoint' : 'data-programme-recreation-endpoint') || '/api/programmes/' + source;
var params = {};
Object.keys(runtime.state.filters || {}).forEach(function (key) {
var value = runtime.state.filters[key];
if (key === 'status' || value === '' || value === false || value == null) return;
params[key] = value;
});
params.limit = 6;
return { endpoint: endpoint, params: params, programme: true };
}
return {
endpoint: runtime.root.getAttribute('data-opportunities-endpoint') || '/api/opportunities',
params: { surface: 'gcitypartners', type: runtime.state.type, verified: 'true', status: 'open', limit: 6 },
programme: false
};
}
function cacheKey(config) {
return config.endpoint + '?' + new URLSearchParams(config.params || {}).toString();
}
function opportunityUrlKey() {
var params = new URLSearchParams(window.location.search || '');
return ['type', 'programme_source', 'date_from', 'date_to', 'district', 'age_group', 'status', 'free_only', 'online_registration'].map(function (key) { return key + '=' + (params.get(key) || ''); }).join('&');
}
function loadOpportunities(runtime, options) {
runtime.state.navigationKey = opportunityUrlKey();
var config = requestConfig(runtime);
var key = cacheKey(config);
var allowCache = !options || options.allowCache !== false;
abortController(runtime.root.__gcpOpportunityAbortController);
runtime.root.__gcpOpportunityAbortController = createAbortController();
runtime.state.requestSequence += 1;
var sequence = runtime.state.requestSequence;
setFeedState(runtime, 'loading', words(runtime.root, '正在讀取官方資料…', 'Loading official data…'));
runtime.root.dispatchEvent(new CustomEvent('gcitypartners:opportunities:request', { detail: { type: runtime.state.type } }));
if (allowCache && runtime.state.cache.has(key)) {
renderPayload(runtime, runtime.state.cache.get(key), config);
runtime.status.textContent = words(runtime.root, '顯示本次工作階段已核實快取，正在更新…', 'Showing verified in-session cache while refreshing…');
}
fetchJson(config.endpoint, config.params, runtime.root.__gcpOpportunityAbortController)
.then(function (payload) {
if (sequence !== runtime.state.requestSequence) return;
runtime.state.cache.set(key, payload);
renderPayload(runtime, payload, config);
}).catch(function (error) {
if (error && error.name === 'AbortError') return;
if (sequence !== runtime.state.requestSequence) return;
if (runtime.state.cache.has(key)) {
renderPayload(runtime, runtime.state.cache.get(key), config);
runtime.status.textContent = words(runtime.root, '官方資料暫時不可用；顯示本次工作階段的已核實快取。', 'Official source unavailable; showing verified in-session cache.');
return;
}
setFeedState(runtime, 'error', words(runtime.root, '官方資料暫時不可用。', 'Official data is temporarily unavailable.'));
});
}
function bindOpportunities(root) {
var workspace = root.querySelector('[data-gcp-opportunity-workspace]');
var feed = root.querySelector('[data-gcp-opportunity-feed]');
var board = root.querySelector('[data-gcp-opportunity-board]');
var status = root.querySelector('[data-gcp-opportunity-status]');
var empty = root.querySelector('[data-gcp-opportunity-empty]');
var emptyCopy = root.querySelector('[data-gcp-opportunity-empty-copy]');
var error = root.querySelector('[data-gcp-opportunity-error]');
var intro = root.querySelector('[data-gcp-opportunity-intro]');
var programmeTools = root.querySelector('[data-gcp-programme-tools]');
if (!workspace || !feed || !board || !status || !empty || !error || !intro || !programmeTools) {
markBlocked(root, 'missing-liquid-opportunity-workspace');
return;
}
var runtime = {
root: root,
workspace: workspace,
feed: feed,
board: board,
status: status,
empty: empty,
emptyCopy: emptyCopy || empty.querySelector('p'),
error: error,
intro: intro,
programmeTools: programmeTools,
filterForm: root.querySelector('[data-gcp-programme-filters]'),
programmeSources: Array.prototype.slice.call(root.querySelectorAll('[data-gcp-programme-source]')),
entryCards: Array.prototype.slice.call(workspace.querySelectorAll('[data-gcp-entry-kind="opportunity"][data-gcp-entry-card]')),
typeLinks: Array.prototype.slice.call(root.querySelectorAll('[data-gcp-opportunity-type]')),
state: { type: 'tender', programmeSource: 'recreation', filters: {}, cache: new Map(), requestSequence: 0 }
};
root.__gcpOpportunityRuntime = runtime;
parseUrlState(runtime);
syncOpportunityUi(runtime);
runtime.entryCards.forEach(function (card) {
listen(root, card, 'toggle', function () {
if (!card.open) return;
runtime.entryCards.forEach(function (other) { if (other !== card) other.open = false; });
var nextType = normalizeType(card.getAttribute('data-gcp-opportunity-entry'));
if (runtime.state.type === nextType) { syncOpportunityUi(runtime); return; }
runtime.state.type = nextType;
writeUrlState(runtime, false);
syncOpportunityUi(runtime);
loadOpportunities(runtime);
});
});
runtime.typeLinks.forEach(function (link) {
listen(root, link, 'click', function (event) {
if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
event.preventDefault();
runtime.state.type = normalizeType(link.getAttribute('data-gcp-opportunity-type'));
writeUrlState(runtime, false);
syncOpportunityUi(runtime);
loadOpportunities(runtime);
});
});
runtime.programmeSources.forEach(function (button) {
listen(root, button, 'click', function () {
runtime.state.programmeSource = slug(button.getAttribute('data-gcp-programme-source')) === 'cultural' ? 'cultural' : 'recreation';
writeUrlState(runtime, false);
syncOpportunityUi(runtime);
loadOpportunities(runtime);
});
});
if (runtime.filterForm) {
listen(root, runtime.filterForm, 'submit', function (event) {
event.preventDefault();
runtime.state.filters = readFilters(runtime.filterForm);
writeUrlState(runtime, false);
syncOpportunityUi(runtime);
loadOpportunities(runtime);
});
listen(root, runtime.filterForm, 'reset', function () {
window.setTimeout(function () {
runtime.state.filters = readFilters(runtime.filterForm);
writeUrlState(runtime, false);
syncOpportunityUi(runtime);
loadOpportunities(runtime);
}, 0);
});
}
var retry = root.querySelector('[data-gcp-opportunity-retry]');
if (retry) listen(root, retry, 'click', function () { loadOpportunities(runtime, { allowCache: false }); });
listen(root, window, 'popstate', function () {
if (opportunityUrlKey() === runtime.state.navigationKey) return;
runtime.state.navigationKey = opportunityUrlKey();
var before = cacheKey(requestConfig(runtime));
parseUrlState(runtime);
syncOpportunityUi(runtime);
if (cacheKey(requestConfig(runtime)) !== before) loadOpportunities(runtime);
});
loadOpportunities(runtime);
}
function locationName(item) {
return clean(
item.name_zh || item.name_en || item.nameZH || item.nameEN || item.name ||
item.formatted_address_zh || item.formatted_address_en || item.addressZH || item.addressEN || item.address ||
'Candidate location'
);
}
function locationAddress(item) {
return clean(
item.formatted_address_zh || item.formatted_address_en || item.address_zh || item.address_en ||
item.addressZH || item.addressEN || item.address
);
}
function locationDistrict(item) {
return clean(item.district_zh || item.district_en || item.districtZH || item.districtEN || item.district);
}
function locationEasting(item) {
return clean(item.easting != null ? item.easting : item.x);
}
function locationNorthing(item) {
return clean(item.northing != null ? item.northing : item.y);
}
function locationCoordinateLabel(item) {
var x = locationEasting(item);
var y = locationNorthing(item);
if (x && y) return 'HK80 ' + x + ', ' + y;
var lat = clean(item.lat != null ? item.lat : item.latitude);
var lng = clean(item.lng != null ? item.lng : item.longitude);
return lat && lng ? 'WGS84 ' + lat + ', ' + lng : words(document.documentElement, '座標待核實', 'Coordinates pending');
}
function validLocationEndpoint(raw) {
try {
var url = new URL(clean(raw) || LOCATION_ENDPOINT, window.location.origin);
return url.origin === window.location.origin && url.pathname === LOCATION_ENDPOINT ? url : null;
} catch (_) {
return null;
}
}
function bindLocationSearch(root) {
var shell = root.querySelector('[data-csdi-location-search]');
if (!shell) return;
var endpoint = clean(shell.getAttribute('data-csdi-endpoint') || root.getAttribute('data-csdi-location-search-endpoint') || LOCATION_ENDPOINT);
var input = root.querySelector('[data-csdi-location-query]');
var button = root.querySelector('[data-csdi-location-search-button]');
var results = root.querySelector('[data-csdi-location-results]');
var status = root.querySelector('[data-csdi-location-status]');
var selected = root.querySelector('[data-csdi-selected-location]');
var meta = root.querySelector('[data-csdi-location-meta]');
var state = root.querySelector('[data-csdi-location-state]');
var coordinate = root.querySelector('[data-csdi-coordinate-label]');
var briefForm = (root.hasAttribute('data-gcp-public-tabs') ? document : root).querySelector('[data-gcp-brief-only-form]');
function briefField(name) { return briefForm && briefForm.elements ? briefForm.elements.namedItem(name) : null; }
var projectLocation = briefField('project_location');
var description = briefField('description');
var csdiLocationName = briefField('csdi_location_name');
var csdiLocationAddress = briefField('csdi_location_address');
var csdiLocationDistrict = briefField('csdi_location_district');
var csdiLocationX = briefField('csdi_location_x');
var csdiLocationY = briefField('csdi_location_y');
var csdiSource = briefField('csdi_source');
var lastQuery = '';
if (!input || !button || !results || !status) return;
function announce(message) { status.textContent = message; }
function selectCandidate(item, trigger) {
var name = locationName(item);
var address = locationAddress(item);
var district = locationDistrict(item);
var x = locationEasting(item);
var y = locationNorthing(item);
if (selected) selected.textContent = name;
if (meta) meta.textContent = 'Digital Policy Office Address Lookup Service / 數字政策辦公室地址查詢服務';
if (state) state.textContent = words(root, '候選地址已核對', 'Candidate address checked');
if (coordinate) coordinate.textContent = locationCoordinateLabel(item);
if (projectLocation) projectLocation.value = name || address;
if (csdiLocationName) csdiLocationName.value = name;
if (csdiLocationAddress) csdiLocationAddress.value = address;
if (csdiLocationDistrict) csdiLocationDistrict.value = district;
if (csdiLocationX) csdiLocationX.value = x;
if (csdiLocationY) csdiLocationY.value = y;
if (csdiSource) csdiSource.value = 'hk-dpo-address-lookup-service';
if (briefForm) briefForm.setAttribute('data-gcp-csdi-context', 'selected');
if (description && !description.dataset.csdiFilled) {
description.value = words(
root,
'候選地址已由數字政策辦公室 Address Lookup Service 初步核對：',
'Candidate address checked against the Digital Policy Office Address Lookup Service: '
) + name + (address ? ' · ' + address : '') + (district ? ' · ' + district : '') + '. ' + locationCoordinateLabel(item) + '.';
description.dataset.csdiFilled = 'true';
}
Array.prototype.forEach.call(results.querySelectorAll('.gcp-location-result'), function (candidate) {
candidate.setAttribute('aria-selected', candidate === trigger ? 'true' : 'false');
});
root.setAttribute('data-location-selected', 'true');
root.setAttribute('data-location-provider', 'hk-dpo-als');
announce(words(root, '已選擇候選地址：', 'Selected candidate address: ') + name + words(root, '。只作地址與位置初步核對。', '. For preliminary address and location checking only.'));
}
function renderCandidates(items) {
results.replaceChildren();
if (!items.length) {
results.hidden = true;
announce(words(root, '未找到候選地址，請改用更完整地址或樓宇名稱。', 'No candidate address found. Try a more complete address or building name.'));
return;
}
items.slice(0, 3).forEach(function (item) {
var name = locationName(item);
var address = locationAddress(item);
var district = locationDistrict(item);
var candidate = createElement('button', 'gcp-location-result');
candidate.type = 'button';
candidate.setAttribute('aria-selected', 'false');
candidate.appendChild(createElement('strong', '', name));
candidate.appendChild(createElement('span', '', [address, district].filter(Boolean).join(' · ') || words(root, '香港候選地址', 'Hong Kong address candidate')));
candidate.appendChild(createElement('small', '', locationCoordinateLabel(item)));
listen(root, candidate, 'click', function () { selectCandidate(item, candidate); });
var li = createElement('li');
li.appendChild(candidate);
results.appendChild(li);
});
results.hidden = false;
root.removeAttribute('data-location-selected');
announce(words(root, '已返回 ', 'Returned ') + items.slice(0, 3).length + words(root, ' 個候選地址。', ' candidate addresses.'));
}
function runSearch() {
var query = clean(input.value);
if (query.length < 2) {
announce(words(root, '請輸入至少 2 個字。', 'Enter at least 2 characters.'));
return;
}
if (query === lastQuery && !results.hidden) {
announce(words(root, '相同關鍵字已搜尋，請選擇候選地址。', 'Same keyword already searched. Select a candidate address.'));
return;
}
var url = validLocationEndpoint(endpoint);
if (!url) {
root.setAttribute('data-location-search-state', 'blocked');
announce(words(root, '地址搜尋入口未通過同源驗證。', 'Address search endpoint failed same-origin validation.'));
return;
}
lastQuery = query;
abortController(root.__gcpLocationAbortController);
root.__gcpLocationAbortController = createAbortController();
results.hidden = true;
results.replaceChildren();
root.setAttribute('data-location-search-state', 'loading');
announce(words(root, '正在搜尋官方地址候選…', 'Searching official address candidates…'));
url.searchParams.set('q', query);
window.fetch(url.toString(), {
method: 'GET',
credentials: 'same-origin',
headers: { Accept: 'application/json' },
signal: root.__gcpLocationAbortController && root.__gcpLocationAbortController.signal
}).then(function (response) {
return response.json().catch(function () { return {}; }).then(function (payload) {
if (!response.ok || payload.ok === false || payload.success === false) throw new Error('location_search_' + response.status);
return payload;
});
}).then(function (payload) {
root.setAttribute('data-location-search-state', 'ready');
renderCandidates(asArray(payload));
}).catch(function (error) {
if (error && error.name === 'AbortError') return;
root.setAttribute('data-location-search-state', 'error');
announce(words(root, '官方地址查詢暫時未能返回結果；可先手動填寫地址。', 'Official address lookup is unavailable. Enter the address manually.'));
});
}
listen(root, button, 'click', runSearch);
listen(root, input, 'keydown', function (event) {
if (event.key !== 'Enter') return;
event.preventDefault();
runSearch();
});
}
function teardownGcpPageSystem(root) {
if (!root) return;
(root.__gcpPageSystemCleanups || []).forEach(function (cleanup) { try { cleanup(); } catch (_) {} });
root.__gcpPageSystemCleanups = [];
abortController(root.__gcpLocationAbortController);
abortController(root.__gcpOpportunityAbortController);
root.__gcpLocationAbortController = null;
root.__gcpOpportunityAbortController = null;
root.__gcpOpportunityRuntime = null;
root.removeAttribute('data-gcitypartners-ready');
root.removeAttribute('data-runtime-state');
root.removeAttribute('data-runtime-reason');
}
function initRoot(root) {
if (!root) return null;
if (root.getAttribute('data-gcitypartners-ready') === VERSION) return root;
teardownGcpPageSystem(root);
root.setAttribute('data-gcitypartners-ready', VERSION);
root.setAttribute('data-runtime-owner', 'assets/gcitypartners-page-system.js');
root.setAttribute('data-runtime-state', 'ready');
registerEndpoints(root);
if (slug(root.getAttribute('data-page-mode') || 'gateway') === 'gateway' || root.hasAttribute('data-gcp-public-tabs')) {
bindLocationSearch(root);
bindOpportunities(root);
} else root.setAttribute('data-runtime-state', 'not-required');
return root;
}
function GCityPartnersPageSystemBoot() {
var root = getCanonicalRoot();
if (!root) return null;
return initRoot(root);
}
window.GCityPartnersPageSystemBoot = GCityPartnersPageSystemBoot;
window.GCityPartnersPageSystemTeardown = teardownGcpPageSystem;
if (!window.__gcpPageSystemLifecycleInstalled) {
window.__gcpPageSystemLifecycleInstalled = true;
document.addEventListener('shopify:section:load', function () { GCityPartnersPageSystemBoot(); });
document.addEventListener('shopify:section:unload', function (event) {
var target = event.target;
var root = target && target.matches && target.matches(ROOT_SELECTOR)
? target
: target && target.querySelector
? target.querySelector(ROOT_SELECTOR)
: null;
teardownGcpPageSystem(root);
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', function () { GCityPartnersPageSystemBoot(); }, { once: true });
} else GCityPartnersPageSystemBoot();
})(window, document);
